import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import DataTable from "../../lib/DataTable";
import { Notice, Stat } from "../../lib/ui";
import { printHtml } from "../../lib/format";
import { receiptHtml } from "../../lib/hrDocs";

/* POS payments & receipts – port of GRNreceipts.php (API: /api/pos-payments). "Receipt" prints an A4 receipt with the items sold
   (save as PDF from the print dialog). */


export default function PosPayments() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/pos-payments").then(setRows).catch((e) => setError(e.message)); }, [api]);
  const st = (r) => String(r.status || "").toLowerCase();
  const columns = [
    { key: "payment_id", label: "#", num: true }, { key: "payment_date", label: "Date", render: (r) => String(r.payment_date).slice(0, 10) },
    { key: "client_name", label: "Client", render: (r) => <b style={{ color: "var(--ink)" }}>{r.client_name}</b> }, { key: "payment_method", label: "Method" },
    { key: "payment_amount", label: "Amount", num: true, render: (r) => n2(r.payment_amount) },
    { key: "status", label: "Status", render: (r) => <span className={`pill-tag ${st(r) === "verified" ? "ok" : st(r) === "pending" ? "warn" : ""}`}>{r.status}</span> },
    { key: "rcpt", label: "", sortable: false, render: (r) => <button type="button" className="btn sm" onClick={async () => { try { printHtml(receiptHtml(await api.get(`/api/pos-payments/${r.payment_id}/print`))); } catch (e) { setError(e.message); } }}><i className="fas fa-print" /> Receipt</button> },
  ];
  return (
    <main className="pg">
      <PageHeader slug="GRNreceipts" />
      <Notice notice={error && { tone: "err", text: error }} />
      {rows && <div className="ui-stats">
        <Stat icon="fa-receipt" tone="muted" label="POS payments" value={rows.length} />
        <Stat icon="fa-circle-check" tone="up" label="Verified" value={rows.filter((r) => st(r) === "verified").length} />
        <Stat icon="fa-clock" tone="warn" label="Pending" value={rows.filter((r) => st(r) === "pending").length} />
        <Stat icon="fa-coins" label="Total" value={n0(rows.reduce((s, r) => s + r.payment_amount, 0))} unit="TZS" /></div>}
      <section className="panel">{rows ? <DataTable columns={columns} rows={rows} rowKey={(r) => r.payment_id} searchPlaceholder="Search payments" initialSort={{ key: "payment_id", dir: -1 }} empty="No POS payments." />
        : !error && <div className="empty"><i className="fas fa-spinner fa-spin" />Loading…</div>}</section>
    </main>
  );
}
